/* Vélo Klub theme v2 (22/10: alle teksten in het Engels; 23/10: voorraadregel 'In stock'; knop 'Add to cart';
   producten zonder maten/opties: meteen 'Add to cart' in plaats van 'Select your size') */
(function () {
  'use strict';
  function T(k, d) { var t = window.VK_T; return (t && t[k]) || d; }
  var d = document, body = d.body, cfg = window.VK || {}, root = (cfg.root || '/').replace(/\/?$/, '/');
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function on(el, ev, fn, opt) { el && el.addEventListener(ev, fn, opt); }
  function money(cents) {
    try { return (cents / 100).toLocaleString('en-IE', { style: 'currency', currency: cfg.currency || 'EUR' }); }
    catch (e) { return '€' + (cents / 100).toFixed(2); }
  }
  function html(str) { var t = d.createElement('template'); t.innerHTML = str.trim(); return t.content; }
  function json(url, data) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  var overlays = ['vk-cart-open', 'vk-menu-open', 'vk-search-open', 'vk-filter-open'];
  function closeAll() { overlays.forEach(function (c) { body.classList.remove(c); }); body.style.overflow = ''; }
  function openOverlay(cls) { closeAll(); body.classList.add(cls); body.style.overflow = 'hidden'; }
  on(d, 'click', function (e) {
    var t = e.target.closest('[data-open]');
    if (t) {
      e.preventDefault();
      var w = t.getAttribute('data-open');
      if (w === 'cart') { openOverlay('vk-cart-open'); refreshCart(); }
      if (w === 'menu') openOverlay('vk-menu-open');
      if (w === 'filters') openOverlay('vk-filter-open');
      if (w === 'search') { openOverlay('vk-search-open'); setTimeout(function () { var i = $('#vk-search-input'); i && i.focus(); }, 250); }
      return;
    }
    if (e.target.closest('[data-close]') || e.target.classList.contains('vk-scrim')) closeAll();
  });
  on(d, 'keydown', function (e) { if (e.key === 'Escape') { closeAll(); $$('.vk-modal.is-on,.vk-zoom.is-on').forEach(function (m) { m.classList.remove('is-on'); }); } });

  $$('.vk-ann__in').forEach(function (bar) {
    var msgs = $$('.vk-ann__msg', bar); if (!msgs.length) return;
    msgs[0].classList.add('is-on'); if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 4500);
  });

  var hdr = $('.vk-hdr');
  if (hdr) on(window, 'scroll', function () { hdr.classList.toggle('is-stuck', window.scrollY > 10); }, { passive: true });

  var SECTION = 'vk-cart-drawer';
  function swapCart(sections) {
    if (!sections || !sections[SECTION]) return;
    var fresh = html(sections[SECTION]);
    var newInner = $('[data-cart-inner]', fresh), cur = $('[data-cart-inner]');
    if (newInner && cur) cur.replaceWith(newInner);
    var c = $('[data-cart-count]', fresh);
    var n = c ? c.getAttribute('data-cart-count') : null;
    if (n !== null) $$('[data-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
  }
  function refreshCart() {
    return fetch(root + '?sections=' + SECTION).then(function (r) { return r.json(); }).then(swapCart);
  }
  function busy(v) { var dr = $('.vk-drawer'); dr && dr.classList.toggle('is-busy', v); }
  function addItems(items, btn) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    return json(root + 'cart/add.js', { items: items, sections: SECTION })
      .then(function (res) { swapCart(res.sections); openOverlay('vk-cart-open'); })
      .catch(function (err) {
        openOverlay('vk-cart-open');
        var b = $('[data-cart-error]'); if (b) { b.textContent = (err && (err.description || err.message)) || T('error', 'Something went wrong. Please try again.'); b.hidden = false; }
      })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  }
  window.VKCart = { add: addItems, refresh: refreshCart };
  on(d, 'click', function (e) {
    var a = e.target.closest('[data-add]');
    if (a) { e.preventDefault(); addItems([{ id: Number(a.getAttribute('data-add')), quantity: 1 }], a); return; }
    var q = e.target.closest('[data-line]');
    if (q) {
      e.preventDefault(); busy(true);
      json(root + 'cart/change.js', { line: Number(q.getAttribute('data-line')), quantity: Number(q.getAttribute('data-qty')), sections: SECTION })
        .then(function (res) { swapCart(res.sections); if (body.classList.contains('vk-t-cart')) location.reload(); })
        .catch(function () {}).finally(function () { busy(false); });
    }
  });

  $$('[data-tabs]').forEach(function (wrap) {
    var sec = wrap.closest('section') || d;
    $$('[role="tab"]', wrap).forEach(function (t) {
      on(t, 'click', function () {
        $$('[role="tab"]', wrap).forEach(function (o) { o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
        $$('[data-panel]', sec).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== t.getAttribute('data-target'); });
      });
    });
  });
  on(d, 'click', function (e) {
    var b = e.target.closest('[data-rail]'); if (!b) return;
    var sec = b.closest('section'); var panel = sec && ($('[data-panel]:not([hidden]) .vk-rail', sec) || $('.vk-rail', sec)); if (!panel) return;
    panel.scrollBy({ left: (b.getAttribute('data-rail') === 'next' ? 1 : -1) * panel.clientWidth * 0.9, behavior: 'smooth' });
  });

  var si = $('#vk-search-input'), sres = $('#vk-search-results'), st, sdefault = sres ? sres.innerHTML : '';
  if (si && sres) {
    on(si, 'input', function () {
      clearTimeout(st);
      var q = si.value.trim();
      if (q.length < 2) { sres.innerHTML = sdefault; return; }
      st = setTimeout(function () {
        fetch(root + 'search/suggest?q=' + encodeURIComponent(q) + '&section_id=vk-predictive-search&resources[type]=product,collection,query&resources[limit]=8')
          .then(function (r) { return r.text(); })
          .then(function (t) { var f = html(t); var inner = $('[data-predictive]', f); sres.innerHTML = ''; if (inner) sres.appendChild(inner); });
      }, 220);
    });
  }

  var results = $('[data-results]');
  function filterUrl(form) {
    var params = new URLSearchParams(new FormData(form));
    $$('input[type="number"]', form).forEach(function (i) { if (!i.value) params.delete(i.name); });
    var sort = $('[data-sort]'); if (sort) params.set('sort_by', sort.value);
    return location.pathname + '?' + params.toString();
  }
  function loadResults(url, push) {
    if (!results) return;
    results.classList.add('is-loading');
    var sid = results.getAttribute('data-section');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid).then(function (r) { return r.text(); }).then(function (t) {
      var f = html(t);
      ['[data-results]', '[data-toolbar-count]', '[data-active]', '[data-filter-form]', '[data-fbtn-count]'].forEach(function (s) {
        var n = $(s, f), o = $(s); if (n && o) o.replaceWith(n);
      });
      results = $('[data-results]');
      bindFilters();
      if (push) history.replaceState({}, '', url);
    });
  }
  function bindFilters() {
    var form = $('[data-filter-form]');
    if (form && !form._vk) {
      form._vk = true;
      on(form, 'change', function () { loadResults(filterUrl(form), true); });
      on(form, 'submit', function (e) { e.preventDefault(); closeAll(); });
    }
  }
  if (results) {
    bindFilters();
    var sortSel = $('[data-sort]');
    on(sortSel, 'change', function () { var form = $('[data-filter-form]'); loadResults(form ? filterUrl(form) : location.pathname + '?sort_by=' + sortSel.value, true); });
    on(d, 'click', function (e) {
      var a = e.target.closest('[data-active] a, [data-clear]');
      if (a) { e.preventDefault(); loadResults(a.getAttribute('href'), true); return; }
      var m = e.target.closest('[data-loadmore]');
      if (m) {
        e.preventDefault(); m.setAttribute('aria-busy', 'true');
        fetch(m.getAttribute('href') + '&section_id=' + results.getAttribute('data-section')).then(function (r) { return r.text(); }).then(function (t) {
          var f = html(t);
          var grid = $('[data-grid]', f), cur = $('[data-grid]');
          if (grid && cur) $$(':scope > *', grid).forEach(function (n) { cur.appendChild(n); });
          var lm = $('[data-loadmore-wrap]', f), clm = $('[data-loadmore-wrap]');
          if (clm) { if (lm) clm.replaceWith(lm); else clm.remove(); }
        });
      }
    });
  }
  on(d, 'click', function (e) {
    var t = e.target.closest('[data-clamp-toggle]'); if (!t) return;
    var el = $(t.getAttribute('data-clamp-toggle')); if (!el) return;
    el.classList.toggle('is-clamped'); t.textContent = el.classList.contains('is-clamped') ? T('read_more', 'Read more') : T('show_less', 'Show less');
  });

  $$('[data-product]').forEach(function (pr) {
    var data; try { data = JSON.parse($('[data-product-json]', pr).textContent); } catch (e) { return; }
    var form = $('[data-product-form]', pr), idInput = form && $('[name="id"]', form);
    var priceEl = $('[data-price]', pr), atc = $('[data-atc]', pr), stock = $('[data-stock]', pr);
    var sticky = $('.vk-sticky-buy'), stickyBtn = sticky && $('[data-sticky-atc]', sticky), stickyPrice = sticky && $('[data-sticky-price]', sticky);
    function sel() { return $$('[data-option]', pr).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function current() {
      if (!$$('[data-option]', pr).length) return data.variants[0];
      var s = sel();
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return s[i] === o; }); });
    }
    function update() {
      var opts = $$('[data-option]', pr);
      opts.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var s = sel(); s[idx] = inp.value;
          var any = data.variants.some(function (v) { return v.available && v.options.every(function (o, i) { return s[i] === null || s[i] === o; }); });
          inp.closest('.vk-opt__v').classList.toggle('is-out', !any);
        });
        var c = $('input:checked', fs), lbl = $('[data-selected]', fs); if (lbl) lbl.textContent = c ? c.value : '';
      });
      var v = current();
      if (!v) {
        if (atc) { atc.disabled = false; atc.textContent = T('select', 'Select your size'); }
        if (stickyBtn) stickyBtn.textContent = T('select', 'Select your size');
        return;
      }
      idInput.value = v.id;
      var sale = v.compare_at_price > v.price;
      if (priceEl) priceEl.innerHTML = (sale ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '<span' + (sale ? ' class="vk-price--sale"' : '') + '>' + money(v.price) + '</span>';
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? T('add', 'Add to cart') : T('sold_out', 'Sold out'); }
      if (stickyBtn) stickyBtn.textContent = v.available ? T('add', 'Add to cart') : T('sold_out', 'Sold out');
      if (stock) {
        var q = (data.inventory || {})[v.id], txt = $('span', stock);
        stock.className = 'vk-stock';
        if (!v.available) { stock.classList.add('is-out'); txt.textContent = T('sold_out_size', 'Sold out in this size'); }
        else if (typeof q === 'number' && q > 0 && q <= 3) { stock.classList.add('is-low'); txt.textContent = T('only', 'Only [q] left').replace('[q]', q); }
        else { txt.textContent = T('in_stock', 'In stock'); }
      }
      if (opts.length) { var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); }
    }
    $$('[data-option] input', pr).forEach(function (i) { on(i, 'change', update); });
    if (form) on(form, 'submit', function (e) {
      e.preventDefault();
      var v = current();
      if (!v) { var fs = $$('[data-option]', pr).find(function (f) { return !$('input:checked', f); }); if (fs) { fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); fs.classList.add('is-warn'); } return; }
      var q = $('[name="quantity"]', form);
      addItems([{ id: v.id, quantity: q ? Number(q.value) || 1 : 1 }], atc);
    });
    on(pr, 'click', function (e) {
      var b = e.target.closest('[data-qty-step]'); if (!b) return;
      var inp = $('[name="quantity"]', pr); inp.value = Math.max(1, (Number(inp.value) || 1) + Number(b.getAttribute('data-qty-step')));
    });
    if (stickyBtn) on(stickyBtn, 'click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(atc);
    }
    var gal = $('.vk-gallery', pr), dots = $$('.vk-gallery__dots i', pr);
    if (gal && dots.length) on(gal, 'scroll', function () { var i = Math.round(gal.scrollLeft / gal.clientWidth); dots.forEach(function (dt, k) { dt.classList.toggle('is-on', k === i); }); }, { passive: true });
    var zoom = $('.vk-zoom', pr);
    on(gal, 'click', function (e) {
      var it = e.target.closest('.vk-gallery__item'); if (!it || !zoom || window.innerWidth < 900) return;
      zoom.classList.add('is-on'); var idx = $$('.vk-gallery__item', gal).indexOf(it);
      var img = $$('img', zoom)[idx]; if (img) img.scrollIntoView();
    });
    on(zoom, 'click', function () { zoom.classList.remove('is-on'); });
    update();
  });
  on(d, 'click', function (e) {
    var t = e.target.closest('[data-modal]'); if (t) { e.preventDefault(); var m = $(t.getAttribute('data-modal')); if (m) m.classList.add('is-on'); return; }
    if (e.target.classList.contains('vk-modal') || e.target.closest('[data-modal-close]')) { var mm = e.target.closest('.vk-modal'); if (mm) mm.classList.remove('is-on'); }
  });

  $$('[data-open-now]').forEach(function (el) {
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Brussels' }));
    var day = now.getDay(), h = now.getHours() + now.getMinutes() / 60, open = false;
    if (day >= 2 && day <= 6 && h >= 10 && h < 18) open = true;
    if (day === 0 && now.getDate() <= 7 && h >= 13 && h < 18) open = true;
    el.classList.toggle('is-closed', !open);
    $('span', el).textContent = open ? T('open_now', 'Open now until 18:00') : T('closed_now', 'Closed now');
  });

  $$('[data-news]').forEach(function (f) {
    on(f, 'submit', function () {
      var tags = ['newsletter'].concat($$('[data-tag]:checked', f).map(function (c) { return c.getAttribute('data-tag'); }));
      var h = $('[name="contact[tags]"]', f); if (h) h.value = tags.join(',');
    });
  });

  $$('[data-box]').forEach(function (box) {
    var max = Number(box.getAttribute('data-max')) || 4, boxVariant = box.getAttribute('data-box-variant');
    var items = [], slots = $('[data-box-slots]', box), list = $('[data-box-list]', box), total = $('[data-box-total]', box), btn = $('[data-box-add]', box), cnt = $('[data-box-count]', box);
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function render() {
      slots.innerHTML = '';
      for (var i = 0; i < max; i++) {
        var it = items[i];
        slots.insertAdjacentHTML('beforeend', '<div class="vk-box__slot">' + (it ? '<img src="' + esc(it.img) + '" alt=""><button type="button" data-box-rm="' + i + '" aria-label="Remove">×</button>' : '') + '</div>');
      }
      list.innerHTML = items.map(function (it) { return '<li><span>' + esc(it.title) + ' · ' + esc(it.size) + '</span><span>' + money(it.price) + '</span></li>'; }).join('');
      var sum = items.reduce(function (s, it) { return s + it.price; }, 0);
      total.textContent = money(sum); cnt.textContent = items.length + ' / ' + max;
      btn.disabled = items.length === 0;
    }
    on(box, 'click', function (e) {
      var a = e.target.closest('[data-box-pick]');
      if (a) {
        if (items.length >= max) { cnt.textContent = T('box_full', 'Your box is full ([n])').replace('[n]', max); return; }
        items.push({ id: Number(a.getAttribute('data-box-pick')), size: a.textContent.trim(), title: a.getAttribute('data-title'), price: Number(a.getAttribute('data-price')), img: a.getAttribute('data-img') });
        render(); return;
      }
      var r = e.target.closest('[data-box-rm]'); if (r) { items.splice(Number(r.getAttribute('data-box-rm')), 1); render(); return; }
      var tab = e.target.closest('[data-box-tab]');
      if (tab) {
        $$('[data-box-tab]', box).forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        $$('[data-box-cat]', box).forEach(function (p) { p.hidden = p.getAttribute('data-box-cat') !== tab.getAttribute('data-box-tab'); });
      }
    });
    on(btn, 'click', function () {
      var ref = 'BOX-' + Date.now().toString(36).toUpperCase();
      var payload = items.map(function (it) { return { id: it.id, quantity: 1, properties: { 'Gift box': ref } }; });
      if (boxVariant) payload.push({ id: Number(boxVariant), quantity: 1, properties: { 'Gift box': ref } });
      addItems(payload, btn).then(function () { items = []; render(); });
    });
    render();
  });
})();
